import { permissionsList, permissionsDetail, permissionsDelete, permissionsStatus } from './request';
import fieldModel from './fieldModel';
import authorityModel from './authorityModel';
export default {
  components: {
    fieldModel,
    authorityModel
  },
  data() {
    return {
      columns: [{
        slots: {
          title: 'id'
        },
        dataIndex: 'id',
        key: '1',
        align: 'center',
        width: 80
      }, {
        slots: {
          title: '权限名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center',
        scopedSlots: {
          customRender: 'name'
        },
        ellipsis: true
      }, {
        slots: {
          title: '权限描述'
        },
        dataIndex: 'description',
        key: 'description',
        align: 'center',
        scopedSlots: {
          customRender: 'name'
        },
        ellipsis: true
      }, {
        slots: {
          title: '类型'
        },
        dataIndex: 'type',
        key: '3',
        align: 'center',
        scopedSlots: {
          customRender: 'type'
        }
      }, {
        slots: {
          title: '关联权限id'
        },
        dataIndex: 'associationId',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '开放状态'
        },
        dataIndex: 'isOpen',
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'isOpen'
        }
      }, {
        slots: {
          title: '在线状态'
        },
        dataIndex: 'status',
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '操作'
        },
        key: '8',
        align: 'center',
        width: 230,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      form: {
        name: '',
        isOpen: 0
      },
      fieldVisible: false,
      currentRow: {},
      authorityDialogVisible: false
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    seachFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      permissionsList(obj).then(res => {
        console.log(res);
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    async permissionsFun(data) {
      this.currentRow = data;
      if (data.id) {
        this.currentRow = await permissionsDetail({
          permissionsId: data.id
        });
      }
      this.authorityDialogVisible = true;
    },
    delItem(val) {
      if (this.data.length != 0) {
        this.$message.error(this.$t('由于部门内有账号，不能删除'));
        return false;
      }
      let _this = this;
      this.$alert(_this.$t('是否确认删除该数据?'), {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        permissionsDelete({
          structureId: val.id
        }).then(res => {
          _this.$message.success(_this.$t('删除成功'));
          _this.getDataFun();
        });
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    async checkedFun(checked, id) {
      await permissionsStatus({
        permissionsId: id,
        status: checked ? 1 : 0
      });
      this.$message.success(this.$t('保存成功'));
      this.getDataFun();
    },
    isChecked(text) {
      return text;
    },
    configureFun(val, type) {
      this.fieldVisible = true;
      this.$nextTick(() => {
        this.$refs.fieldRef.init(val, type);
      });
    },
    handleOk() {
      this.dialogVisible = false;
      this.currentRow = {};
      this.getDataFun();
    }
  }
};